@solidale.controller 'LocModifyCtrl', ['$rootScope', '$scope', '$timeout', '$q', 'Location', '$mdDialog', ($rootScope, $scope, $timeout, $q, Location, $mdDialog) ->

	$pageRender = () ->

		$scope.search_cond = 
			name: ''
			uid: ''

		$scope.inFocus = ''	
		$scope.inFocusItem = []

		$timeout ()->
			$scope.search_cond.uid = $rootScope.user.uid 
			
			$scope.$watch 'search_cond.name', ()->
				$LocationSearch()
			
		, 500
	
	$rootScope.$watch 'isAdmin', ()->
		if $rootScope.isAdmin
			$pageRender()

	# ================	
	# Search 	
	# ================
	$LocationSearch = () ->
		Location.querymy({ uid: $scope.search_cond.uid, name: $scope.search_cond.name }).then (resp)->

			$scope.locations = resp.data

			if $scope.locations.length > 0
				for loc in $scope.locations

					if loc.available_roomphotos.length > 0
						loc.back = loc.available_roomphotos[0].path + loc.available_roomphotos[0].image_name
					else
						loc.back = ''

	
	# ================
	# Modify
	# ================			
	$scope.openModify = (loc) ->

		$scope.inFocus = true

		# infocus initial
		$scope.inifocusitem()
		$scope.inFocusItem = loc

	$scope.$watch 'inFocus', ()->
		if $scope.inFocus == false
			$pageRender()
		
]